<template>
    <button
        type="button"
        :class="classes"
        v-on="$listeners"
        v-bind="$attrs"
    >
        <slot />
    </button>
</template>

<script>
import { PALETTES } from 'design-assets/constants/palettes.js';
import { SIZES } from 'design-assets/constants/sizes.js';
import VueTypes from 'commons/util/vue-types.js';

export default {
    props: {
        palette: VueTypes.oneOf(Object.values(PALETTES)).def(PALETTES.NONE),
        isCta: VueTypes.bool.def(false),
        isInverted: VueTypes.bool.def(false),
        isLink: VueTypes.bool.def(false),
        size: VueTypes.string.def(SIZES.LARGE),
        isFullWidth: VueTypes.bool.def(false),
    },
    computed: {
        classes() {
            return {
                'vf-button': true,
                'vf-no-outline': true,
                'is-cta': this.isCta,
                'is-link': this.isLink,
                'is-inverted': this.isInverted,
                [this.paletteClass]: this.hasPalette,
                [this.sizeClass]: true,
                'vf-button__full-width': this.isFullWidth,
            };
        },
        hasPalette() {
            return this.palette !== PALETTES.NONE;
        },
        paletteClass() {
            return `is-${this.palette}-color`;
        },
        sizeClass() {
            return `is-size-${this.size}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './buttons';
</style>
